// extracted by mini-css-extract-plugin
export default {"personalInput":"OrderSummary_personalInput__ROb33","mainContainer":"OrderSummary_mainContainer__AX+e2","formContainer":"OrderSummary_formContainer__wgIX-"};